import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionValidator, parseState, RichMediaState, useBaseModules } from '@bonusly/common-action-input';

import { Award } from '../../../../../../../types/bonus';
import { useSharedAwardConfig } from './useSharedAwardConfig';

interface UseTemplatedAwardConfig {
	onSuccess?: VoidFunction;
}

export const useTemplatedAward = (award: Award, options: UseTemplatedAwardConfig = {}) => {
	const { t } = useTranslation('recognition');
	const config = useSharedAwardConfig(award, options);
	const { amount } = parseState(award.reason);

	const modules = useBaseModules({
		includeGif: true,
		includeAttachment: true,
		includeRecipient: true,
		includePrivacy: true,
		includeVideoRecording: true,
	});

	const validator = useMemo(() => {
		return new ActionValidator({
			requireRecipient: true,
		});
	}, []);

	const calculateTotalFn = useCallback(
		(data: RichMediaState) => {
			return data.recipientCount * (amount || 0);
		},
		[amount]
	);

	return {
		context: 'templated-award',
		giveAmount: amount,
		modules,
		placeholder: t('awards.give_modal.recipient_tag'),
		calculateTotalFn,
		validator,
		...config,
	};
};
